import styled from 'styled-components';

export const SearchLabel = styled.label`
  display: block;
  font-family: "proletarsk", Helvetica, sans-serif;
  font-size: 1.8rem;
  color: #acb4c9;
  text-transform: uppercase;
`;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/styles/SearchLabel.js